module.exports = __webpack_public_path__ + "img/wrk-tablet_01832f55ca028727f990cc7448621b3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/wrk-tablet.jpg
// module id = 299
// module chunks = 0